import { Controller } from "@hotwired/stimulus"
import { LogoHelper } from "~/helpers/logo_helper";

export default class extends Controller {
  static get targets() {
    return ["logo", "input", "clear"]
  }

  select(event) {
    this.logoTarget.src = LogoHelper.companyLogoUrl(event.detail.domain)
    this.logoTarget.classList.remove("hidden")
    this.clearTarget.classList.remove("hidden")
  }

  clear() {
    this.logoTarget.classList.add("hidden")
    this.clearTarget.classList.add("hidden")
    this.logoTarget.src = ""
    this.inputTarget.value = ""
    this.inputTarget.focus()
  }
}
